/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Patient/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import PatientPicker from './PatientPicker/index'
import ProfileActions from 'DesignSystem/ProfileActions/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Patient({
  children,
  viewPath = "/DesignSystem/TasksViewForm/Content/Content/Patient"
  
}) {
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
let taskPatientValueData = fromData.useDataValue({ viewPath,
context: 'task',
path: 'patient',
})
let taskPatientIdValueData = fromData.useDataValue({ viewPath,
context: 'task',
path: 'patient._id',
})
let taskPatientPersonValueData = fromData.useDataValue({ viewPath,
context: 'task',
path: 'patient.person',
})
  return (<React.Fragment
>
<div
  data-testid="Patient.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-124axH': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Patient.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral600}
 text="Patient"
/>
</div>
<PatientPicker
  viewPath={`${viewPath}/PatientPicker`}
/>
<fromFlow.When is={taskPatientValueData}>
<ProfileActions
  viewPath={`${viewPath}/ProfileActions`}
 data="task.patient"
 type="ghost"
 marginLeft="auto"
 data="task.patient._id"
 patient_id={taskPatientIdValueData}
 data="task.patient.person"
 person={taskPatientPersonValueData}
/>
</fromFlow.When>
</div>
{children}
</React.Fragment>)
}